<template>
  <SharedLink url="/contact">
    <slot></slot>
  </SharedLink>
</template>

<script lang="ts" setup></script>

<style></style>
